import { db } from '../lib/firebase';
import { collection, addDoc, deleteDoc, doc, query, where, getDocs, onSnapshot } from 'firebase/firestore';

// Database structure: vindie/{collection}

export interface BookLibraryItem {
  id: string;
  userId: string;
  bookId: string;
  bookTitle: string;
  bookCover: string;
  bookAuthor: string;
  addedAt: Date;
}

export const addBookToLibrary = async (userId: string, bookId: string, bookData: {
  title: string;
  cover: string;
  author: string;
}): Promise<void> => {
  try {
    await addDoc(collection(db, 'bookLibrary'), {
      userId,
      bookId,
      bookTitle: bookData.title,
      bookCover: bookData.cover,
      bookAuthor: bookData.author,
      addedAt: new Date()
    });
  } catch (error) {
    console.error('Error adding book to library:', error);
    throw error;
  }
};

export const removeBookFromLibrary = async (userId: string, bookId: string): Promise<void> => {
  try {
    const q = query(
      collection(db, 'bookLibrary'),
      where('userId', '==', userId),
      where('bookId', '==', bookId)
    );
    const querySnapshot = await getDocs(q);
    
    querySnapshot.forEach(async (docSnapshot) => {
      await deleteDoc(doc(db, 'bookLibrary', docSnapshot.id));
    });
  } catch (error) {
    console.error('Error removing book from library:', error);
    throw error;
  }
};

export const isBookInLibrary = async (userId: string, bookId: string): Promise<boolean> => {
  try {
    const q = query(
      collection(db, 'bookLibrary'),
      where('userId', '==', userId),
      where('bookId', '==', bookId)
    );
    const querySnapshot = await getDocs(q);
    return !querySnapshot.empty;
  } catch (error) {
    console.error('Error checking if book is in library:', error);
    return false;
  }
};

export const getUserBookLibrary = (userId: string, callback: (books: BookLibraryItem[]) => void) => {
  const q = query(
    collection(db, 'bookLibrary'),
    where('userId', '==', userId)
  );
  
  return onSnapshot(q, 
    (querySnapshot) => {
      const books: BookLibraryItem[] = [];
      querySnapshot.forEach((doc) => {
        books.push({
          id: doc.id,
          ...doc.data()
        } as BookLibraryItem);
      });
      callback(books);
    },
    (error) => {
      console.error('Book library listener error:', error);
      // Don't throw the error, just log it
    }
  );
};


